import { ALTERAR_REGISTROS_POR_PAGINA_MDFE } from '../types'

export default function alterarRegistrosPorPaginaMdfe(registros) {
  return {
    type: ALTERAR_REGISTROS_POR_PAGINA_MDFE,
    payload: registros
  }
}
